import React, { createContext, useState, useEffect } from 'react';
import { api } from '../utils/api';

const ProgramOfferedContext = createContext();

const PROGRAM_ORDER = ["cee-preparation", "ioe-engineering-entrance"];

function sortPrograms(programs) {
  return [...programs].sort((a, b) => {
    const ai = PROGRAM_ORDER.indexOf(a.slug);
    const bi = PROGRAM_ORDER.indexOf(b.slug);
    if (ai === -1 && bi === -1) return 0;
    if (ai === -1) return 1;
    if (bi === -1) return -1;
    return ai - bi;
  });
}

const ProgramOfferedProvider = ({ children }) => {
  const [programOffered, setProgramOffered] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    api
      .get('/api/programs')
      .then((res) => {
        setProgramOffered(sortPrograms(res.documents));
        setLoading(false);
      })
      .catch((err) => {
        setError(err.message);
        setLoading(false);
      });
  }, []);

  return (
    <ProgramOfferedContext.Provider value={{ programOffered, loading, error }}>
      {children}
    </ProgramOfferedContext.Provider>
  );
};

export { ProgramOfferedContext, ProgramOfferedProvider };
